import React, { SyntheticEvent, FC, useState } from 'react';

import {
	Dialog,
	DialogContent,
	DialogActions,
	CircularProgress,
	DialogTitle,
	LinearProgress,
	Tooltip,
} from '@material-ui/core';

import InfoOutlined from '@material-ui/icons/InfoOutlined';

import { CloseButton } from 'components/common/commonComponentsTSX';

import { makeStyles } from '@material-ui/core/styles';

import { UserThemeContext } from '../../../../theme/context';

export type KEnquete = {
	id: string;
	titulo: string;
	opcoes_resposta: Array<{ id: number; descricao: string; enquete: number }>;
	votos: Array<{ id: number; descricao: string; qtd: number }>;
	qtdVotosRestantes: number;
	situacao: string;
};

type ModalResultadoEnqueteProps = {
	enqueteData: KEnquete;
	open: boolean;
	onClose: (event: SyntheticEvent<boolean>, reason: 'backdropClick' | 'escapeKeyDown') => void;
};

const ModalResultadoEnquete: FC<ModalResultadoEnqueteProps> = ({ enqueteData, open, onClose }) => {
	const [loading, setLoading] = useState(false);
	const { theme } = React.useContext(UserThemeContext);

	let votosRestantes = enqueteData && enqueteData.qtdVotosRestantes;
	let totalVotes = 0;

	if (enqueteData && enqueteData.votos) {
		totalVotes = enqueteData.votos.reduce((sum, vote) => sum + vote.qtd, 0);
		votosRestantes = enqueteData.qtdVotosRestantes - totalVotes;
	}

	const useStyles = makeStyles((theme) => ({
		progressBar: {
			backgroundColor: '#2F345D',
		},
		emptyBar: {
			backgroundColor: '#7481a5',
		},

		progressLabel: {
			position: 'absolute',
			padding: '12px 0',
			zIndex: 1,
			display: 'flex',
			gap: '410px',
		},
	}));

	const classes = useStyles();

	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			PaperProps={{
				style: {
					minWidth: '30vw',
					position: 'relative',
				},
			}}
		>
			<div
				style={{
					marginTop: '12px',
					fontSize: '18px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<DialogTitle>Resultado da Enquete</DialogTitle>
				<Tooltip
					title={
						<>
							<p style={{ textAlign: 'center' }}>Entendendo o Gráfico</p>
							<p>1 - O resultado dos votos é baseado somente nas pessoas que votaram.</p>
							<p>
								2 - As pessoas autorizadas para votar e que não votaram, serão contabilizadas na legenda
								abaixo do gráfico.
							</p>
							<p>3 - As pessoas não autorizadas a votar, não serão computadas.</p>
						</>
					}
				>
					<InfoOutlined />
				</Tooltip>
			</div>
			<div style={{ height: '1px', backgroundColor: theme === 'dark' ? 'white' : 'black' }}></div>
			<DialogContent>
				<div
					style={{
						marginTop: '12px',
						fontSize: '18px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<span style={{ fontWeight: 'bold', paddingRight: '5px' }}>Título:</span>
					<span>{enqueteData.titulo}</span>
				</div>
				{!enqueteData.votos || enqueteData.votos.every((voto) => voto.qtd === 0) ? (
					<div
						style={{
							marginTop: '20px',
						}}
					>
						<span>Não há votos para a enquete: {enqueteData.titulo}</span>
					</div>
				) : (
					enqueteData &&
					enqueteData.votos &&
					enqueteData.opcoes_resposta &&
					enqueteData.opcoes_resposta.map((item, index) => {
						const percentage =
							totalVotes > 0 ? ((enqueteData.votos[index].qtd / totalVotes) * 100).toFixed(2) : '0';
						const maxPercentage = enqueteData.votos.reduce((max, vote) => Math.max(max, vote.qtd), 0);
						const isMaxPercentage = enqueteData.votos[index].qtd === maxPercentage ? 'bold' : 'normal';
						return (
							<div key={item.id}>
								<div style={{ marginRight: '50px', marginTop: '20px', marginBottom: '5px' }}>
									<span style={{ fontWeight: isMaxPercentage }}>{item.descricao}</span>
								</div>
								<div className={classes.progressLabel}>
									<span
										style={{
											color: 'white',
											marginLeft: '20px',
											width: '20px',
											fontWeight: isMaxPercentage,
										}}
									>
										{percentage}%
									</span>
									<span
										style={{
											fontWeight: isMaxPercentage,
											color: 'white',
										}}
									>
										{enqueteData && enqueteData.votos[index].qtd}{' '}
										{enqueteData && enqueteData.votos[index].qtd === 1 ? 'voto' : 'votos'}
									</span>
								</div>

								<div>
									<LinearProgress
										classes={{
											bar: classes.progressBar,
											root: classes.emptyBar,
										}}
										variant='determinate'
										value={parseFloat(percentage)}
										style={{
											height: '40px',
											border: '1px solid black',
											borderRadius: '3px',
										}}
									/>
								</div>
							</div>
						);
					})
				)}
				{enqueteData && enqueteData.situacao == 'E' ? (
					<div style={{ marginTop: '8px' }}>
						<span>
							<strong>* Total de pessoas que restam votar: </strong>
							{votosRestantes}
						</span>
					</div>
				) : null}
			</DialogContent>
			<DialogActions>
				<CloseButton onClick={onClose} size='small'>
					{(loading && <CircularProgress size={20} />) || 'Voltar'}
				</CloseButton>
			</DialogActions>
		</Dialog>
	);
};

export default ModalResultadoEnquete;
